import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

const CardDeck = ({ children, height, width, scrollable = false, onDeadSpaceClick, className = '' }) => (
  <div
    className={
      classNames({
        'deck-of-cards': true,
        scrollable,
        [className]: true,
      })
    }
    style={{
      height: height - 2, // -2 accounts for border overlap
      width: width - 2, // -2 accounts for border overlap
    }}
    onClick={onDeadSpaceClick}
  >
    {children}
  </div>
);

export default CardDeck;

CardDeck.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  scrollable: PropTypes.bool,
  height: PropTypes.number,
  width: PropTypes.number,
  onDeadSpaceClick: PropTypes.func,
  className: PropTypes.string,
};
